import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/@shared';
import { DemoV1RoutingModule } from './demo.v1.routing.module';

@NgModule({
  declarations: [
  ],
  imports: [
    SharedModule,
    DemoV1RoutingModule
  ]
})

export class DemoV1Module { }
